import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// Components
import Button from '../../Button/Button';
import { TextInput } from 'carbon-components-react';

const UpdatePreset = ({
  setOpenModal,
  data,
  presets,
  updatePreset
}) => {
  const [presetName, setPresetName] = useState(data.name);
  const [isInvalid, setInvalid] = useState(false);

  useEffect(() => {
    if(presetName) {
      let foundIndex = presets.findIndex(preset => preset.name.toLowerCase() === presetName.toLowerCase());
      if(foundIndex !== -1) {
        setInvalid(true);
      } else {
        setInvalid(false);
      }
    }
  }, [presetName, presets]);

  return (
    <Container>
      <ContentContainer>
        <TextInput 
          id="preset-title-input"
          value={presetName}
          labelText="Preset Name"
          // placeholder="Enter New Preset Name"
          invalid={isInvalid}
          invalidText="A preset with that name already exists, please select a different name."
          onChange={e => setPresetName(e.target.value)}/>
      </ContentContainer>
      <ActionContainer>
        <Button 
          size="lg" 
          variant="outlined" 
          onClick={() => setOpenModal(false)}
          style={{ marginRight: 16 }}>
          Cancel
        </Button>
        <Button 
          size="lg"
          disabled={isInvalid}
          variant="primary"
          onClick={() => updatePreset({ ...data, name: presetName })}>
          Save
        </Button>
      </ActionContainer>
    </Container>
  );
};

export default UpdatePreset;

const Container = styled.div`

`

const ContentContainer = styled.div`
  width: 70%;
  margin-bottom: 56px;
`

const ActionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`